export default "__VITE_ASSET__Boswqqbz__"